import api from '../axios'

/**
 * @description 官网/商城共用的销售联系方式。游客可访问，失败由调用方走写死兜底。
 */
export const salesContactApi = {
  /**
   * @param {{ salesOrganization: 'TDC'|'IPC' }} params
   * @returns {Promise<{ phone: string|null, email: string|null }>}
   */
  getAgentCertificationContact: (params) =>
    api.get('/store/channel-certification/agent-contact', {
      params,
      showError: false,
    }),
}
